// src/components/button/FolderSortSelector.tsx

import { ExpandLessTwoTone, ExpandMoreTwoTone } from '@mui/icons-material'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { MouseEvent } from 'react'

import { ASC, DESC } from '../../api'

type Props = {
  data?: { title: string; value: string }[]
  onChange: (event: MouseEvent<HTMLElement>, newValue: string) => void
  order: string
  orderby: string
}

export const FolderSortSelector = ({
  data = [
    { title: 'Name', value: 'name' },
    { title: 'ID', value: 'entity_id' },
  ],
  onChange,
  order,
  orderby,
  ...rest
}: Props) => (
  <ToggleButtonGroup exclusive onChange={onChange} value={orderby} {...rest}>
    {data.map(item => (
      <ToggleButton key={item.title} value={item.value}>
        {item.title}
        {item.value === orderby && order === ASC && <ExpandLessTwoTone />}
        {item.value === orderby && order === DESC && <ExpandMoreTwoTone />}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
)
